import React from "react";
import {Doughnut} from 'react-chartjs-2';
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import {getStrRgba, getStrRgbaAlpha1} from "../../../utility/common";
import NsDashboardCard from "../../../components/NsDashboardCard";

// Registrare i componenti necessari di Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

export default function DashboardKpiStatiView({
                                                  info,
                                              }) {

    return (
        <NsDashboardCard
            title={'Avanzamento Indicatori'}
            classiAggiuntive={"ns-card--h340"}
        >
            <Doughnut
                style={{maxHeight: '200px'}}
                data={{
                    labels: info.map((inf) => inf.stato_kpi),
                    datasets: [
                        {
                            data: info.map((inf) => inf.num),
                            backgroundColor: info.map((inf) => getStrRgba(inf.colore)),
                            borderColor: info.map((inf) => getStrRgbaAlpha1(inf.colore)),
                            borderWidth: 1,
                        },
                    ],
                }}
                options={{
                    plugins: {
                        legend: {
                            position: 'bottom'
                        }
                    },
                }}
            />
        </NsDashboardCard>
    );
}